export enum emailTypesKeys {
    BRANDED_SHIPMENT_CONFIRMATION = 'shipment-confirmation',
}
